<script lang="ts">
  import type { Image } from "types/backend/models/cms/image.entity";
  export let image: Partial<Image> = {};
  export let radius = "";
  export let customWidth = "";
  export let customHeight = "";
  export let className = "";
  export let imgStyle = "";
  // export let lazy: boolean;
  // export let highPriority: boolean;
  // export let decoding: boolean;

  $: ({ imgAlt = "", width = 0, height = 0, path } = image || {});

  $: styles = [
    radius ? `border-radius: ${radius}` : "",
    customWidth ? `width: ${customWidth}` : width ? `width: ${width}` : "",
    customHeight ? `height: ${customHeight}` : height ? `height: ${height}` : "",
  ].filter(v => v);

  $: srcset = "";
  // const srcset = `
  // ${path}?width=100 100w
  // ${path}?width=200 200w
  // ${path}?width=300 300w
  // `;
</script>

<picture style={`${styles.join(";")}`}>
  <source type="image/webp" {srcset} />
  <img
    class={className}
    src={path}
    alt={imgAlt}
    loading="lazy"
    decoding="async"
    role="presentation"
    {srcset}
    style={`${styles.join(";")} ${imgStyle}`}
  />
</picture>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  picture {
    text-align: center;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
</style>
